const productTypes = {
  CORE: 'core',
  APP: 'app',
  TRAINING: 'training',
  SUPPORT: 'support',
};

export type ProductType = $Values<typeof productTypes>;
export const { CORE, APP, TRAINING, SUPPORT } = productTypes;
